import toast from "react-hot-toast";

import { v4 as uuidv4 } from "uuid";

import MultiImageChooser from "components/lib/Choosers/MultiImageChooser";

import { FieldProps, IdeaFileValue } from "./FieldProps";

const MultiImage = ({
  field,
  fieldValue: images = [],
  ideaId,
  isEditing,
  updateIdea,
}: FieldProps) => {
  const imageFiles = (Array.isArray(images) ? images : []) as IdeaFileValue[];

  const addImages = (
    files: {
      savedName: string;
      fileName: string;
      signedDownloadRequest: string;
    }[],
  ) => {
    if (field.maxFiles && imageFiles.length + files.length > field.maxFiles) {
      toast.error("Your uploads exceed the maximum number of files allowed");
      return;
    }

    const updatedImages = [
      ...files.map((file) => ({
        value: file.signedDownloadRequest,
        name: file.fileName,
        url: file.signedDownloadRequest,
        _id: uuidv4(),
      })),
      ...imageFiles,
    ];
    updateIdea(updatedImages, ["templated", field.id]);
  };

  const removeImage = (fileId: string) => {
    const updatedImages = imageFiles.filter((i) => i._id !== fileId);
    updateIdea(updatedImages, ["templated", field.id]);
  };

  const maxImages = field.maxImages || 10;

  return (
    <MultiImageChooser
      editing={isEditing}
      onComplete={addImages}
      deleteFile={removeImage}
      forType="idea"
      forId={ideaId}
      getFileUrl={(image) =>
        typeof image.value === "string" ? image.value : ""
      }
      images={
        imageFiles as Array<{
          _id: string;
          name: string;
          value: string;
          url: string;
        }>
      }
      maxImages={maxImages}
    />
  );
};

export default MultiImage;
